"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormField = void 0;
var tslib_1 = require("tslib");
var FormField_1 = require("@reactionable/core/lib/form/FormField");
var react_1 = tslib_1.__importDefault(require("react"));
var Feedback_1 = tslib_1.__importDefault(require("react-bootstrap/Feedback"));
var FormCheck_1 = tslib_1.__importDefault(require("react-bootstrap/FormCheck"));
var FormControl_1 = tslib_1.__importDefault(require("react-bootstrap/FormControl"));
var FormGroup_1 = tslib_1.__importDefault(require("react-bootstrap/FormGroup"));
var FormLabel_1 = tslib_1.__importDefault(require("react-bootstrap/FormLabel"));
function isFormCheckProps(props) {
    return props.field.checked !== undefined;
}
function FormField(_a) {
    var label = _a.label, children = _a.children, props = tslib_1.__rest(_a, ["label", "children"]);
    var renderChildren = function (fieldProps) {
        var fieldContent = react_1.default.createElement(react_1.default.Fragment, null);
        if (fieldProps.error) {
            fieldContent = react_1.default.createElement(Feedback_1.default, { type: "invalid" }, fieldProps.error);
        }
        if ('function' === typeof children) {
            fieldContent = (react_1.default.createElement(react_1.default.Fragment, null,
                children(fieldProps),
                fieldContent));
        }
        else {
            if (isFormCheckProps(fieldProps)) {
                var formCheckProps = tslib_1.__assign(tslib_1.__assign({}, fieldProps.field), { checked: !!fieldProps.field.value });
                fieldContent = (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(FormCheck_1.default, tslib_1.__assign({}, formCheckProps, { children: children })),
                    fieldContent));
            }
            else {
                fieldContent = (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(FormControl_1.default, tslib_1.__assign({}, fieldProps.field, { children: children })),
                    fieldContent));
            }
            if (fieldProps.field.type === 'hidden') {
                return fieldContent;
            }
        }
        return (react_1.default.createElement(FormGroup_1.default, { controlId: fieldProps.field.name },
            label && react_1.default.createElement(FormLabel_1.default, null, label),
            fieldContent));
    };
    var formFieldProps = tslib_1.__assign(tslib_1.__assign({}, props), { children: renderChildren });
    return react_1.default.createElement(FormField_1.FormField, tslib_1.__assign({}, formFieldProps));
}
exports.FormField = FormField;
//# sourceMappingURL=FormField.js.map